import { ChevronDownIcon } from '@heroicons/react/16/solid';
import './ScrollButton.styles.scss';
import { tScrollButtonProps } from './ScrollButton.types.ts';

export default function ScrollButton(props: tScrollButtonProps) {
  return (
    <button
      onClick={() => {
        if (props.messagesEndRef.current) {
          props.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }}
      className="ScrollButton"
    >
      <ChevronDownIcon className="ScrollButton__Icon" />
      {props.pendingMessagesOnChat > 0 && (
        <div className="ScrollButton__MessagesCounter">
          {props.pendingMessagesOnChat}
        </div>
      )}
    </button>
  );
}
